import type { VoiceChatParticipation } from 'generated/openapi';
import { type HTMLAttributes, memo } from 'react';

import { VOICE_CHAT_PARTICIPATION_MAP } from '@/features/profile/utils/voiceChatParticipation';
import { Badge } from '@/shared/components/ui/badge';
import { Card } from '@/shared/components/ui/card';

export interface ProfileDetailsVibeVoiceChatParticipationProps extends HTMLAttributes<HTMLDivElement> {
  voiceChatParticipation?: VoiceChatParticipation;
}

export const ProfileDetailsVibeVoiceChatParticipation = memo(
  function ProfileDetailsVibeVoiceChatParticipation({
    voiceChatParticipation,
    ...props
  }: ProfileDetailsVibeVoiceChatParticipationProps) {
    if (!voiceChatParticipation) return null;

    return (
      <Card variant="data" {...props}>
        <p className="text-sm leading-5 font-bold">Mic check</p>
        <Badge variant="display">
          {VOICE_CHAT_PARTICIPATION_MAP.get(voiceChatParticipation)?.icon}
          {VOICE_CHAT_PARTICIPATION_MAP.get(voiceChatParticipation)?.label}
        </Badge>
      </Card>
    );
  },
);
